import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import StatusBadge from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { PlusCircle, Search } from "lucide-react";

export default function RequestsList() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/requests").then((r) => setItems(r.data.requests || []));
  }, []);

  const filtered = items.filter((r) =>
    !q ||
    (r.request_number || "").toLowerCase().includes(q.toLowerCase()) ||
    (r.part_name || "").includes(q) ||
    (r.factory_name || "").includes(q)
  );

  return (
    <DashboardLayout>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <div className="text-xs font-bold tracking-widest text-brand-amber mb-2">الطلبات</div>
          <h1 className="text-3xl font-bold text-brand-navy">جميع الطلبات</h1>
        </div>
        {user.role === "factory_customer" && (
          <Link to="/app/new-request"><Button className="btn-cta" data-testid="new-request-btn"><PlusCircle className="w-4 h-4 me-2" /> طلب جديد</Button></Link>
        )}
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mb-4 flex items-center gap-3">
        <Search className="w-4 h-4 text-slate-400" />
        <Input placeholder="ابحث برقم الطلب، اسم القطعة، أو المصنع..." value={q} onChange={(e) => setQ(e.target.value)} className="border-0 focus-visible:ring-0" data-testid="requests-search" />
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="requests-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs">
              <tr>
                <th className="px-4 py-3 text-start">رقم الطلب</th>
                <th className="px-4 py-3 text-start">القطعة</th>
                {user.role !== "factory_customer" && <th className="px-4 py-3 text-start">المصنع</th>}
                <th className="px-4 py-3 text-start">الكمية</th>
                <th className="px-4 py-3 text-start">المادة</th>
                <th className="px-4 py-3 text-start">التسليم</th>
                <th className="px-4 py-3 text-start">الحالة</th>
                <th className="px-4 py-3 text-start"></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`request-row-${r.request_number}`}>
                  <td className="px-4 py-3 font-semibold text-brand-navy">{r.request_number}</td>
                  <td className="px-4 py-3">{r.part_name}</td>
                  {user.role !== "factory_customer" && <td className="px-4 py-3 text-slate-600">{r.factory_name}</td>}
                  <td className="px-4 py-3">{r.quantity}</td>
                  <td className="px-4 py-3 text-slate-600">{r.material || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{r.delivery_date?.slice(0, 10) || "—"}</td>
                  <td className="px-4 py-3"><StatusBadge status={r.status} /></td>
                  <td className="px-4 py-3 text-end"><Link to={`/app/requests/${r.id}`} className="text-brand-amber font-semibold" data-testid={`view-request-${r.request_number}`}>عرض</Link></td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={8} className="px-4 py-12 text-center text-slate-500">لا توجد نتائج.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
